import React from "react";
import { ppcAdvertisers } from "../../../../core/data/counts";
import { isPinnedAdvertiser, isHighlightedAdvertiser } from "../../../../core/data/pinHighlight";
import { PIN, HIGHLIGHT } from "../../../../core/theme/reportTheme";

// pinKey: the pinned advertiser, highlighted with a "Pinned" tag (pale purple).
// highlightKeys: advertisers highlighted in yellow (the pin's purple wins).
export default function PPCPage({ results, pinKey, highlightKeys }) {
  const advertisers = ppcAdvertisers(results);

  if (advertisers.length === 0) return (
    <div className="bg-white border border-slate-200 rounded-xl px-6 py-16 text-center">
      <p className="text-3xl mb-3">💰</p>
      <p className="font-semibold text-slate-700">No PPC Ads Found</p>
      <p className="text-sm text-slate-400 mt-1">No paid ads were found for these keywords and locations.</p>
    </div>
  );

  return (
    <div className="space-y-5">
      <div className="bg-blue-50 border border-blue-200 rounded-xl px-6 py-4">
        <p className="text-sm text-blue-800"><span className="font-semibold">{advertisers.length} PPC advertiser{advertisers.length !== 1 ? "s" : ""} found.</span> Ranked by frequency.</p>
      </div>
      {advertisers.map((adv, i) => {
        const pinned = isPinnedAdvertiser(adv.name, pinKey);
        const highlighted = !pinned && isHighlightedAdvertiser(adv.name, highlightKeys);
        return (
          <div key={adv.name} className={`bg-white border border-slate-200 rounded-xl overflow-hidden ${pinned ? PIN.card : highlighted ? HIGHLIGHT.card : ""}`}>
            <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <span className="w-7 h-7 rounded-full bg-blue-100 text-blue-700 text-xs font-bold flex items-center justify-center">{i + 1}</span>
                <div>
                  <p className="font-semibold text-slate-800 text-sm flex items-center gap-2">
                    {adv.name}
                    {pinned && <span className={PIN.tag}>Pinned</span>}
                    {highlighted && <span className={HIGHLIGHT.tag}>Highlighted</span>}
                  </p>
                  <div className="flex gap-1 mt-0.5">{[...adv.locations].map(l => <span key={l} className="text-xs bg-slate-100 text-slate-500 px-1.5 py-0.5 rounded">{l}</span>)}</div>
                </div>
              </div>
              <span className="text-xs font-semibold bg-blue-100 text-blue-700 px-3 py-1 rounded-full">Seen {adv.count}x</span>
            </div>
            <div className="px-6 py-4 space-y-3">
              {adv.ads.map((ad, j) => (
                <div key={j} className={`border rounded-lg p-4 ${pinned ? PIN.ad : highlighted ? HIGHLIGHT.ad : "bg-violet-50 border-slate-100"}`}>
                  <p className="text-sm font-semibold text-blue-700">{ad.title}</p>
                  <p className="text-xs text-green-700 mt-0.5">{ad.url_shown}</p>
                  <p className="text-xs text-slate-600 mt-1.5">{ad.desc}</p>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
